import {
  CommonModule,
} from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { LabelMode } from "src/utils/label-mode.enum";
import { GenerateRandom } from "src/utils/random";

@Component({
  selector: "app-textarea",
  templateUrl: "./textarea.component.html",
  styleUrls: ["./textarea.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
})
export class TextareaComponent implements OnInit, OnDestroy {
  @ViewChild("textareaBox") textareaBox: ElementRef;

  @Input() name = GenerateRandom(6);
  @Input() label: string;
  @Input() addonLabel = "";
  @Input() placeholder = "";
  @Input() rows = 2;
  @Input() classes: string;
  @Input() showErrorMessage = true;
  @Input() required = false;
  @Input() minHeightClass = "min-h-125px";

  @Output() valueChange = new EventEmitter();

  LabelMode = LabelMode;
  mode: LabelMode = LabelMode.DEFAULT;

  form = new FormControl();
  subscription: Subscription;

  errorMessage = "";
  isError = false;

  constructor() {}

  @Input()
  set isDisabled(value: boolean) {
    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input()
  set error(value: unknown) {
    this.isError = false;
    this.errorMessage = "";

    if (value !== null && value !== undefined && value !== false) {
      this.isError = true;
      const errorKey = typeof value === "object" ? Object.keys(value)[0] : "";
      switch (errorKey) {
        case "required":
          this.errorMessage = "VALIDATOR.REQUIRED";
          return;
        default:
          this.errorMessage = Array.isArray(value)
            ? String(value[0])
            : typeof value === "string" ||
                typeof value === "number" ||
                typeof value === "boolean"
              ? String(value)
              : "";
      }
    }
  }

  @Input()
  set value(value: any) {
    if (value !== undefined) {
      this.writeValue(value);
    }
  }

  @Input() set labelMode(value: LabelMode) {
    this.mode = value;
  }

  onChange = (value: string) => {};
  onTouched = (value: string) => {};

  ngOnInit(): void {
    this.subscription = this.form.valueChanges.subscribe((value) => {
      this.valueChange.emit(value);
      this.onChange(value);
      // if (this.textareaBox) {
      //   this.textareaBox.nativeElement.style.height = "auto";
      //   this.textareaBox.nativeElement.style.height = `${
      //     this.textareaBox.nativeElement.scrollHeight + 3
      //   }px`;
      // }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  writeValue(obj: any): void {
    // Use patchValue fot unmatch key
    this.form.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}
}
